"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileMetaSchema = void 0;
var document_js_1 = require("./document.js");
Object.defineProperty(exports, "FileMetaSchema", { enumerable: true, get: function () { return document_js_1.FileMetaSchema; } });
